/**
 * CMP多言語対応
 *
 * navigator.languageからベース言語を取得し、translationsオブジェクトから
 * 該当言語のテキストを解決する。該当言語がなければdefaultLanguageにフォールバック。
 */

/**
 * ブラウザの言語設定からベース言語コードを取得する
 * 例: "en-US" → "en", "ja" → "ja"
 * @returns {string}
 */
export function detectLanguage() {
  const lang = navigator.language || navigator.userLanguage || '';
  return lang.split('-')[0].toLowerCase();
}

/**
 * 翻訳テキストを解決する
 * @param {Object} translations - { ja: {...}, en: {...} }
 * @param {string} defaultLanguage - フォールバック言語
 * @returns {Object} 該当言語のテキストオブジェクト
 */
export function resolveTexts(translations, defaultLanguage) {
  const lang = detectLanguage();

  // 完全一致
  if (translations[lang]) {
    return translations[lang];
  }

  // defaultLanguage
  if (translations[defaultLanguage]) {
    return translations[defaultLanguage];
  }

  // translationsの最初のキー
  const firstKey = Object.keys(translations)[0];
  if (firstKey) {
    return translations[firstKey];
  }

  return {};
}
